<div>
  <button
    *showAuthed="true"
    (click)="DelAccountAuthModal.show()"
    type="button"
    class="btn m-b-10 btn-md btn-block btn-danger"
  >
    <i class="icofont icofont-trash"></i>
    <span>Delete your account?</span>
    <!-- Content marker -->
    <ng-content></ng-content>
  </button>

  <del-account-auth-modal
    #DelAccountAuthModal
    [currentUser]="currentUser"
    [hideFooter]="true"
  >
  </del-account-auth-modal>
</div>
